import api from "../services/api";

const service_path = '/activity-log.php';

/**
 * Lista logs de atividade com filtros e paginação.
 * @param {Object} filters - Filtros (todos opcionais)
 * @param {number} filters.page - Página (padrão: 1)
 * @param {number} filters.per_page - Itens por página (1-100, padrão: 20)
 * @param {string} filters.action - Ex: login
 * @param {string} filters.entity_type - Ex: orders
 * @param {number} filters.user_id - ID do usuário
 * @param {string} filters.user_type - admin ou customer
 * @param {string} filters.date_from - YYYY-MM-DD
 * @param {string} filters.date_to - YYYY-MM-DD
 */
export function getActivityLogs(filters = {}) {
    const cleanFilters = Object.entries(filters).reduce((acc, [key, value]) => {
        if (value !== '' && value !== null && value !== undefined) {
            acc[key] = value;
        }
        return acc;
    }, {});

    const params = new URLSearchParams(cleanFilters).toString();
    const url = params ? `${service_path}?${params}` : service_path;

    return api.get(url);
}
